'use client';
import { createContext } from '@radix-ui/react-context';
import createLooseContext from '../../hooks/use-loose-context.mjs';
import { MODAL_NAME, MODAL_CONTAINER_NAME, MODAL_NAVIGATION_NAME } from './constants.mjs';

// src/components/modal/contexts.ts
var [ModalProvider, useModalContext] = createContext(MODAL_NAME);
var [ModalContainerProvider, useModalContainerContext] = createContext(MODAL_CONTAINER_NAME);
var [ModalActionAreaProvider, useModalActionAreaContext] = createLooseContext(MODAL_CONTAINER_NAME);
var [ModalNavigationProvider, useModalNavigationContext] = createContext(MODAL_NAVIGATION_NAME);

export { ModalActionAreaProvider, ModalContainerProvider, ModalNavigationProvider, ModalProvider, useModalActionAreaContext, useModalContainerContext, useModalContext, useModalNavigationContext };
